import React, { useState } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label from 'components/general/Label';


export const Medal = ({ code, showDescription = true }) => {

    const [showImage, setShowImage] = useState(true);
    let description = code;


    const hideImg = () => {
        setShowImage(false);
    };
    let classname = "medal ";
    if (code === "1")
        classname += " gold";
    else if (code === "2")
        classname += " silver";
    else if (code === "3")
        classname += " bronze";
    let descCode = "LabelMedalDesc" + code;
    description = Label({ data: descCode })

    return (
        <>
            {showImage ? (
                <div title={description} onError={hideImg} className={classname}></div>
            ) : (
                description
            )}
        </>

    )
};

export const MedalMemo = React.memo(Medal);

export default Medal

